import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import AimsCredentialsStore from "../../../stores/credentials/aims-credentials-store";

interface IIntegrationProps {
    credentialsStore: AimsCredentialsStore,
    vGroup: IValidationGroup,
}

const AimsCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='AIMS360 API client ID' required key='client_id'>
                <Input
                    value={credentialsStore.client_id}
                    onChange={v => credentialsStore.client_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='AIMS360 API secret' required key='client_secret'>
                <Input
                    value={credentialsStore.client_secret}
                    onChange={v => credentialsStore.client_secret = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='AIMS360 username' required key='username'>
                <Input
                    value={credentialsStore.username}
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='AIMS360 password' required key='password'>
                <Input
                    value={credentialsStore.password}
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default AimsCredentials;
